import React, { Component } from 'react';
import { ColorButton, TransparentButton, DeleteModal } from '../../../../../neoverv';
import { Badge } from 'react-bootstrap';
import Autoload from '../../../../../neoverv/Autoload';
import moment from 'moment';
import { connect } from 'react-redux';
import { Group, SegmentedControl, SimpleGrid, Skeleton, Stack } from '@mantine/core';
import StarterPackageCard from '../../../../../assets/images/module/general/StarterPackageCard.svg';
import PremiumPackageCard from '../../../../../assets/images/module/general/PremiumPackageCard.svg';
import ProfessionalPackageCard from '../../../../../assets/images/module/general/ProfessionalPackageCard.svg';
import CrossIcon from '../../../../../assets/images/module/general/CrossIcon.svg';
import StarterBadgeIcon from '../../../../../assets/images/module/general/StarterBadgeIcon.svg';
import PremiumBadgeIcon from '../../../../../assets/images/module/general/PremiumBadgeIcon.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import ProfessionalBadgeIcon from '../../../../../assets/images/module/general/ProfessionalBadgeIcon.svg';
import UtilityBillingAssignedIcon from '../../../../../neoverv/components/SVGs/utilityBillingAssigned';
import PaymentTemplateModal from '../../../../../neoverv/components/Module/General/CustomModal/PaymentTemplateModal';
import SubscriptionBadgeIcon from '../../../../../neoverv/components/SVGs/SubscriptionBadgeIcon';
import PaymentTemplateSuccessModal from '../../../../../neoverv/components/Module/General/CustomModal/PaymentTemplateSuccessModal';
import RestrictedMenuMessageModal from '../../../../../neoverv/components/Module/General/CustomModal/RestrictedMenuMessageModal';
import { showNotification } from '@mantine/notifications';
import {
  BILLING_PERIOD,
  getBillingPeriod,
  isAnnualSubscription,
  getMonthlyEquivalentPrice,
  getMaxAnnualSavingsPercent,
  formatSavingsPercent,
} from '../../../../../helpers/subscriptionBilling';
import AnnualBillingSummary from '../../../../../components/AnnualBillingSummary';
import { SUBSCRIPTION_CATEGORY, getSubscriptionTier, isStarterTier } from '../../../../../helpers/subscriptionFeatureAccess';

// Plan descriptions and contents as on the website's plan comparison
// (https://hellohousing.de/ki-immobilienverwaltungssoftware/) - keep both in line.
const PACKAGE_CONTENT = {
  [SUBSCRIPTION_CATEGORY.STARTER]: {
    description: 'Ihr Einstieg in die digitale Immobilienverwaltung – mit der hellohousing KI und Nebenkostenabrechnung als PDF.',
    features: [
      '1 Immobilie',
      'Bis zu 9 Mieteinheiten',
      'hellohousing KI',
      'Belegmanager',
      'Dokumentenverwaltung',
      'Nebenkostenabrechnung als PDF',
      'Nachrichten via E-Mail',
      'Digitaler Briefversand',
    ],
  },
  [SUBSCRIPTION_CATEGORY.PREMIUM]: {
    description: 'Digitale Immobilienverwaltung mit Heizkostenabrechnung nach HKVO, automatisierter Buchhaltung und hellohousing KI.',
    features: [
      '2 Immobilien',
      'Bis zu 25 Mieteinheiten je Immobilie',
      'hellohousing KI',
      'Belegmanager',
      'Dokumentenverwaltung',
      'Bankkonto einbinden',
      'Automatische Mieteingangskontrolle',
      'Datenexport für Anlage V',
      'Nebenkostenabrechnung als PDF',
      'Heizkostenabrechnung nach HKVO',
      'Nebenkostenabrechnung für Gewerbe',
      'Nachrichten via E-Mail',
      'Digitaler Briefversand',
      'Eigenes Logo & Branding',
    ],
  },
  [SUBSCRIPTION_CATEGORY.PROFESSIONAL]: {
    description: 'Professionelle digitale Immobilienverwaltung mit Funkzählereinbindung (UVI), Mieterportal und der hellohousing KI.',
    features: [
      '5 Immobilien inkl. (flexibel erweiterbar)¹',
      'Unbegrenzte Mieteinheiten je Immobilie',
      'hellohousing KI',
      'Belegmanager',
      'Dokumentenverwaltung',
      'Bankkonten einbinden',
      'Automatische Mieteingangskontrolle',
      'Datenexport für Anlage V',
      'Nebenkostenabrechnung als PDF',
      'Heizkostenabrechnung nach HKVO',
      'Nebenkostenabrechnung für Gewerbe',
      'Nachrichten via E-Mail',
      'Digitaler Briefversand',
      'Eigenes Logo & Branding',
      'Monatliche Verbrauchsinformationen (UVI)',
      'Funkzählereinbindung',
      'Mieterportal',
    ],
  },
};

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, loader } = Autoload.MainHelper;
export class NewSubscription extends Component {
  state = {
    subscriptionPlan: null,
    subscriptionlastDate: '',
    openModal: false,
    subscriptionData: [
      {
        subscriptionRenewDate: '',
        subscriptionAmount: '',
        subscriptionBilling: '',
        subscriptionKey: '',
      },
    ],
    skeletonLoading: false,
    currentSubs: null,
    openPaymentRedirectModal: false,
    subscribtionSelected: null,
    subscribtionSelectedName: null,
    subscriptionTypes: [],
    paymentMandate: null,
    nextSubscription: null,
    openPaymentStatusModal: false,
    type: 'authorize',
    openRestrictedMenuMessage: false,
    isReactivating: false,
    billingPeriod: BILLING_PERIOD.ANNUAL, // annual is the default per the ticket
  };

  onInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  componentDidMount() {
    loader(false);
    this.setState({currentSubs: this.props.currentSubscription}, ()=> {
      if(this.props.history?.location?.state){
        const {subscriptionData, subscribtionSelected, paymentMandate, subscriptionTypes, nextSubscription} = this.props.history.location.state;
        // A plan picked on the overview (e.g. a monthly plan under "Ihre Optionen") opens on its own
        // tab instead of the annual default, so it isn't hidden behind the toggle.
        const preselectedPlan = subscriptionTypes?.find((subscriptionType)=> subscriptionType?.subscriptionTypeId === subscribtionSelected);
        this.setState({subscriptionData, subscribtionSelected, paymentMandate, subscriptionTypes, nextSubscription, ...(preselectedPlan && {billingPeriod: getBillingPeriod(preselectedPlan)})});
      }else{
        this.getsubscriptionsTypes();
      }
    });
  }

  getsubscriptionsTypes = async () => {
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'subscriptions',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_subscriptions_types',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handle_subscriptions_types(response){
    console.log('handle_subscriptions_types: ', response);
    if(response.status){
      this.setState({subscriptionTypes: response.result});
    }
    this.getPaymentDetails();
  }

  getPaymentDetails = (openSubscriptionScreen=false) => {
    console.log('this.props.profile', this.props.profile.accountId, this.props.profile);
    const userAccountID = this.props.profile.accountId;
    // console.log(userAccountID, 'userAccountID from redux - payment details page');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + userAccountID + '/paymentMandate',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_account_payment_details',
      {openSubscriptionScreen},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handle_account_payment_details(response) {
    const {subscribtionSelected} = this.state;
    console.log('handle_account_payment_details response', response);
    if (response.status == true && response.statuscode == 200) {
      this.setState({
        paymentMandate: response.result
      });
    }

    window.Intercom("update", {
      "Payment method": response?.result?.paymentMethod ? (response?.result?.isManuallyCreated && response?.result?.paymentMethod === 'directdebit') ? 'directdebit-hh' : response?.result?.paymentMethod : 'none',
      "Payment mandate id": response?.result?.paymentMandateid ? response?.result?.paymentMandateid : 'none'
    });

    if(response.other.openSubscriptionScreen){
      this.props.history.push('yourSubscription', {selectedSubscription: subscribtionSelected})
    }else{
      this.getsubscriptionsAssignments();
    }
  }

  getsubscriptionsAssignments = async () => {
    document.getElementById('get-all-subscriptions')?.click();
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments?accountId=' + userAccountID,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_subscriptions_Assignments_details',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handle_subscriptions_Assignments_details(response) {
    console.log('profile ssubscription api', response);
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      this.setState({
        subscriptionData: response.result.filter((subscription)=> subscription.subscriptionType.type === 'MAIN').map((data, index) => {
          return {
            subscriptionRenewDate: moment(data.nextRenewalDate).format('DD.MM.YYYY'),
            subscriptionAmount: checkProperty(checkProperty(data, 'subscriptionType'), 'price'),
            subscriptionBilling: checkProperty(checkProperty(data, 'subscriptionType'), 'billing'),
            subscriptionKey: checkProperty(checkProperty(data, 'subscriptionType'), 'subscriptionKey'),
            subscriptionTypeId: checkProperty(checkProperty(data, 'subscriptionType'), 'subscriptionTypeId'),
            subscriptionStatus: checkProperty(data, 'subscriptionStatus'),
            testPeriodEnd: checkProperty(data, 'testPeriodEndDate'),
            subscriptionEndDate: moment(data.testPeriodEndDate).format('DD.MM.YYYY'),
            subscriptionAssignment: checkProperty(data, 'id'),
            nextPaymentDue: moment(data.nextPaymentDate).format('DD.MM.YYYY'),
            cancellatinoDate: moment(data.cancelationDate).format('DD.MM.YYYY'),
          };
        }),
      });
    }

    this.ShowLoader();
  }
  toggleModal = (subscriptionStatus, testPeriodEnd, id, subscriptionRenewDate) => {
    var date = moment(new Date()).format('YYYY-MM-DD');
    var testDate = moment(testPeriodEnd).format('YYYY-MM-DD');
    var testPeriod = moment(date).isSameOrBefore(testDate);

    this.setState({
      subsStatus: subscriptionStatus,
      subsEndPeriod: testPeriodEnd,
      subsId: id,
      testPeriodCheck: testPeriod,
      renewDate: subscriptionRenewDate,
      openModal: !this.state.openModal,
    });
  };
  reactivateCancelSub() {
    const { subsStatus, subsId, testPeriodCheck } = this.state;
    if (subsStatus === 'ACTIVE' && testPeriodCheck === true) {
      //active
      this.cancelSubscriptionAPi(subsId);
    } else if (subsStatus === 'ACTIVE' && testPeriodCheck === false) {
      //over
      this.cancelSubscriptionAPi(subsId);
    } else if (subsStatus === 'CANCELLED') {
      this.reactivateSubscriptinApi(subsId);
    }
  }
  cancelSubscriptionAPi(id) {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments/' + id + '/cancel',
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_cancel_subscription',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handle_cancel_subscription(response) {
    this.setState({ openModal: !this.state.openModal });

    this.getsubscriptionsAssignments();
  }
  reactivateSubscriptinApi(id) {
    if (this.state.isReactivating) return;
    this.setState({ isReactivating: true }); // <-- Prevent multiple clicks

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments/' + id + '/reactivate',
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_reactivate_cancel_subscription',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_reactivate_cancel_subscription = (response) => {
    this.setState({ isReactivating: false }); // <-- Reset state
    if (response.statuscode === 200) {
      var metadata = {
        subscriptionKey: this.props.currentSubscription?.subscriptionKey
      };
      window.Intercom('trackEvent', 'plan-reactivated', metadata);
      showNotification({
        message: 'Die Kündigung wurde erfolgreich rückgängig gemacht.',
        icon: <img src={GreenTick} alt='green-tick'/>,
      });
    }
    this.getsubscriptionsAssignments();
  };

  ShowLoader = () => {
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
    this.setState({skeletonLoading: false});
  };

  render() {
    const {closeNewSubscription, currentSubscription, accountData, isMobile, hasTested} = this.props;
    const {currentSubs, openPaymentRedirectModal, subscribtionSelected, paymentMandate, subscriptionTypes, nextSubscription, openPaymentStatusModal, type, openRestrictedMenuMessage, isReactivating, billingPeriod} = this.state;
    console.log('subscriptionTypes: ', subscriptionTypes);
    const visibleSubscriptionTypes = subscriptionTypes
    .filter((subscriptionType)=> subscriptionType?.subscriptionTypeId.toString().toLowerCase() !== '97F226D5-A137-48E6-AA9A-605D4488DEC7'.toLowerCase())
    //.filter((subscription)=> subscription?.subscriptionKey.includes('2024') || subscription?.subscriptionKey.includes(currentSubscription?.subscriptionKey))
    .filter((subscriptionType)=> getBillingPeriod(subscriptionType) === billingPeriod)
    .sort((a,b)=> a.price - b.price);
    // The plan cards always sit side by side in one row, sized to what's shown (a hard-coded
    // 4-column grid left the usual 3 cards hugging the left edge). The cards are 314px wide, so
    // where the page is narrower than the row, the row scrolls sideways (.subscription-cards-scroll)
    // instead of wrapping cards onto another row.
    const subscriptionCardCols = Math.min(visibleSubscriptionTypes.length, 3) || 1;
    const maxAnnualSavingsPercent = getMaxAnnualSavingsPercent(subscriptionTypes);
    return (
      <div>
        <Group style={{justifyContent: 'flex-end'}}>
          <div>
            <ColorButton
            text={'Zurück'}
            className={'gray-btn'}
            onClick={()=> //closeNewSubscription()
            this.props.history.push('yourSubscription')
            }
            />
          </div>
        </Group>
        {/* The toggle sits in the middle column, so it is centred on the page with the label beside it. */}
        <div className='subscription-period-selector'>
          <span className='subscription-period-selector-label'>Abrechnung:</span>
          <SegmentedControl
            value={billingPeriod}
            onChange={(value)=> this.setState({billingPeriod: value})}
            radius={4}
            fullWidth
            classNames={{
              root: 'subscription-period-toggle',
              label: 'subscription-period-toggle-label',
            }}
            data={[
              {label: 'Monatlich', value: BILLING_PERIOD.MONTHLY},
              {label: (
                <span>
                  Jährlich
                  {maxAnnualSavingsPercent !== null && <span className='subscription-period-savings'>bis {formatSavingsPercent(maxAnnualSavingsPercent)} sparen</span>}
                </span>
              ), value: BILLING_PERIOD.ANNUAL},
            ]}
          />
        </div>
        <div id="response-user-account-subs-details" className='subscription-cards-scroll'>
          <SimpleGrid cols={subscriptionCardCols} className='subscription-cards-row'>
            {visibleSubscriptionTypes
            .map((subscriptionType)=>{
              const isReactivatable = currentSubscription?.subscriptionTypeId === subscriptionType.subscriptionTypeId &&
                        currentSubscription?.subscriptionStatus === 'CANCELLED' &&
                        currentSubscription?.cancellatinoDate &&
                        moment(currentSubscription.cancellatinoDate, 'DD.MM.YYYY').isAfter(moment());
              const paidPlan= subscriptionType.price > 0 ? true : false;
              // Same tier + different billing period (e.g. current Premium monthly, card is
              // Premium annual) must stay selectable - only block re-selecting the exact same
              // tier *and* the exact same billing period the account is already on.
              const isSameTierAndPeriod = subscriptionType?.name === currentSubscription?.subscriptionName && getBillingPeriod(subscriptionType) === getBillingPeriod(currentSubscription);
              // Starter cards skip the checks below so the old free Starter plan can move to a paid one,
              // but that also left a paid Starter subscriber's own plan selectable. The plan the account
              // is actively on is never selectable, whatever the tier.
              const isActiveCurrentPlan = subscriptionType.subscriptionTypeId === currentSubscription?.subscriptionTypeId && currentSubscription?.subscriptionStatus === 'ACTIVE';
              // Labelled from the store's current plan rather than the assignment list passed in from
              // the overview, which can be stale (e.g. this page reopened from the browser history).
              const isCurrentPlan = subscriptionType.subscriptionTypeId === currentSubscription?.subscriptionTypeId;
              const packageContent = PACKAGE_CONTENT[getSubscriptionTier(subscriptionType)] || PACKAGE_CONTENT[SUBSCRIPTION_CATEGORY.PROFESSIONAL];
              const isSubscriptionSelectable = isReactivatable || (!isActiveCurrentPlan && (isStarterTier(subscriptionType) ? true : subscriptionType.subscriptionTypeId !== currentSubscription?.subscriptionTypeId) && subscriptionType.price !== 0 && subscriptionType.subscriptionTypeId !== nextSubscription?.subscriptionTypeId && (currentSubscription?.subscriptionTypeId === '97f226d5-a137-48e6-aa9a-605d4488dec7' || (isStarterTier(subscriptionType) ? true : !isSameTierAndPeriod)));
              return (<Stack gap={5} style={{cursor: isSubscriptionSelectable && 'pointer'}}>
                <span className='current-subscription-title' style={{marginBottom: '7px', textAlign: 'center', height: '17px'}}>{isCurrentPlan && 'Aktuelles Abonnement'}</span>
                <Stack className='new-subscriptions-card' style={{borderColor: subscriptionType.subscriptionTypeId !== nextSubscription?.subscriptionTypeId ? subscriptionType.subscriptionTypeId === subscribtionSelected && '#5555FF' : 'none', borderWidth: subscriptionType.subscriptionTypeId === subscribtionSelected && '2px'}}>
                  <Stack style={{padding: '20px'}} onClick={()=> {
                    if (isReactivatable) {
                      this.reactivateSubscriptinApi(currentSubscription.subscriptionAssignment);
                    } else if (!hasTested && currentSubscription?.subscriptionTypeId !== '97f226d5-a137-48e6-aa9a-605d4488dec7') {
                      this.setState({openRestrictedMenuMessage: true});
                    } else if (isSubscriptionSelectable) {
                      if (paymentMandate) {
                        this.props.history.push('yourSubscription', {selectedSubscription: subscriptionType.subscriptionTypeId});
                      } else {
                        this.setState({openPaymentRedirectModal: true, subscribtionSelected: subscriptionType.subscriptionTypeId, subscribtionSelectedName: subscriptionType.name});
                      }
                    }
                  }}>
                    <Group style={{justifyContent: 'center'}}>
                      {/* <img src={subscriptionType.subscriptionKey.split('_')[0] === 'STARTER' ? StarterBadgeIcon : subscriptionType.subscriptionKey.split('_')[0] === 'PREMIUM' ? PremiumBadgeIcon : ProfessionalBadgeIcon} height={'24px'}/> */}
                      <SubscriptionBadgeIcon name={subscriptionType?.name} category={getSubscriptionTier(subscriptionType)}/>
                    </Group>
                    <Group className='new-subscriptions-card-text' style={{height: '70px', alignItems: 'flex-start'}}>
                      {packageContent.description}
                    </Group>
                    <Stack>
                      <span style={{fontWeight: '600', color: '#13135C'}}>Umfang</span>
                      {packageContent.features.map((feature)=>
                        <Group key={feature} wrap="nowrap" gap={'xs'}>{UtilityBillingAssignedIcon('#5555FF', '12.87', '12.87')}<span style={{fontSize: '12px', color: '#13135C'}}>{feature}</span></Group>
                      )}
                    </Stack>
                  </Stack>
                  <Stack style={{background: '#F2F2F2', padding: '20px 0px', borderEndStartRadius: '7px', borderEndEndRadius: '7px'}}>
                    <Group style={{justifyContent: 'center'}}>
                      {subscriptionType.price === 0 ? 'Kostenlos' : (subscriptionType.subscriptionKey.split('_')[0] === 'TEST' && subscriptionType.subscriptionKey.split('_')[1] === 'PROFESSIONAL') ? 'Täglich kündbar' : isAnnualSubscription(subscriptionType) ? 'Jährlich kündbar' : 'Monatlich kündbar'}
                    </Group>
                    <Group style={{justifyContent: 'center'}}>
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <span className='upgrade-subscription-card-value'>{getMonthlyEquivalentPrice(subscriptionType).toFixed(2).split('.')[0]}<span style={{fontSize: '13px'}}>{paidPlan && getMonthlyEquivalentPrice(subscriptionType).toFixed(2).split('.')[1]}</span>€</span>
                        <span className='upgrade-subscription-card-monat'> / {subscriptionType.billing === 'daily' ? 'täglich' : 'Monat'}</span>
                      </div>
                    </Group>
                    {isAnnualSubscription(subscriptionType) &&
                    <Group style={{justifyContent: 'center', padding: '0 20px'}}>
                      <AnnualBillingSummary className='annual-billing-summary' subscriptionType={subscriptionType} subscriptionTypes={subscriptionTypes}/>
                    </Group>}
                    {isSubscriptionSelectable &&
                    <Group style={{justifyContent: 'center'}}>
                      <div>
                        <ColorButton
                          text={isReactivatable ? 'Jetzt reaktivieren' : currentSubscription?.subscriptionTypeId === '97f226d5-a137-48e6-aa9a-605d4488dec7' ? 'Jetzt freischalten' : hasTested ? 'Jetzt freischalten' : 'Kostenlos testen'}
                          className={'purple-btn'}
                          disabled={subscriptionType.status !== 'Available' || isReactivating}
                          onClick={()=> {
                            if (isReactivatable) {
                              this.reactivateSubscriptinApi(currentSubscription.subscriptionAssignment);
                            } else if (!hasTested && currentSubscription?.subscriptionTypeId !== '97f226d5-a137-48e6-aa9a-605d4488dec7') {
                              this.setState({openRestrictedMenuMessage: true});
                            } else if (paymentMandate) {
                              this.props.history.push('yourSubscription', {selectedSubscription: subscriptionType.subscriptionTypeId});
                            } else {
                              this.setState({openPaymentRedirectModal: true, subscribtionSelected: subscriptionType.subscriptionTypeId, subscribtionSelectedName: subscriptionType.name});
                            }
                          }}
                          showLoader={isReactivating}
                        />
                      </div>
                    </Group>}
                    {getSubscriptionTier(subscriptionType) === SUBSCRIPTION_CATEGORY.PROFESSIONAL &&
                    <Group gap={'xs'} style={{padding: '0 20px'}}>
                      <span style={{fontSize: '10px', color: '#13135C', fontWeight: '400', lineHeight: '14px'}}>1: jede weitere Immobilie 4,50 € / Monat</span>
                    </Group>}
                  </Stack>
                </Stack>
              </Stack>)
            })}
          </SimpleGrid>
        </div>
        {openPaymentRedirectModal &&
        <PaymentTemplateModal
        open={openPaymentRedirectModal}
        toggle={()=>this.setState({openPaymentRedirectModal: false})}
        type={type}
        route={'/profile/yourSubscription'}
        subscribtionSelected={this.state.subscribtionSelected}
        subscribtionSelectedName={this.state.subscribtionSelectedName}
        openPaymentStatusModal={()=> this.setState({openPaymentStatusModal: true})}
        />}
        {openPaymentStatusModal &&
        <PaymentTemplateSuccessModal
        open={openPaymentStatusModal}
        toggle={()=>this.setState({openPaymentStatusModal: false},()=> this.getPaymentDetails(true))}
        type={'authorize'}
        history={this.props.history}
        reAuthorize={()=>
          this.setState({openPaymentRedirectModal: true, type, openPaymentStatusModal: false})
          //this.reAuthorizePayment()
        }
        authorize={()=>
          this.setState({openPaymentRedirectModal: true, type, openPaymentStatusModal: false})
          //this.authorizePayment()
        }
        onNext={()=> this.setState({openPaymentStatusModal: false},()=> this.getPaymentDetails(true))}
        getPaymentDetails={()=> this.getPaymentDetails()}
        getPaymentHistoryTable={()=> null}
        />}
        {openRestrictedMenuMessage &&
        <RestrictedMenuMessageModal
        open={openRestrictedMenuMessage}
        toggle={()=> this.setState({openRestrictedMenuMessage: false})}
        history={this.props.history}
        />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.generalReducer.profile,
    AccountApi: state.generalReducer.account_api_id,
    currentSubscription: state.generalReducer.currentSubscription,
    accountData: state.generalReducer.accountData,
    hasTested: state.generalReducer.hasTested
  };
};

export default connect(mapStateToProps, null)(NewSubscription);
